<div class="account-selector" *ngIf="formEnabled">
  <div id="facility" class="form-group w-300 mr-2 ">
    <ng-select
      wcag-label
      [placeholder]="'ACCOUNTS_MODULE.addUser.selectAccountText' | translate"
      [inputAttrs]="{'aria-label': 'ACCOUNTS_MODULE.addUser.selectAccountText' | translate}"
      [items]="facilityNames"
      [(ngModel)]="dummy"
      bindLabel="name"
      bindValue="id"
      [appendTo]="facility"
      [disabled]="!canDeleteAccount"
      dropdownPosition="bottom"
      (change)="addItem($event)">
    </ng-select>
  </div>
</div>
<div class="account-list">
  <ng-container *ngIf="items.length > 0; else NO_ITEMS">
    <div class="account-item" *ngFor="let accountItem of items; let id = index">
      <span>{{ accountItem.name }}</span>
      <a class="remove btn btn-outline-secondary btn-sm "  *ngIf="formEnabled"
         aria-label="Delete"
         href="#"
         (click)="removeItem($event, id)">
        <!--<i class="pi pi-trash"></i>--> {{ 'ACCOUNTS_MODULE.addUser.delete' | translate }}
      </a>
    </div>
  </ng-container>
  <ng-template #NO_ITEMS>
    <div class="no-items"><span>{{ 'ACCOUNTS_MODULE.addUser.noAccountsText' | translate }}</span></div>
  </ng-template>

</div>
